import React from 'react';

import PropTypes from 'prop-types';
import { Modal, Spacer } from '@telus-uds/components-web';
import { ModalWidthOverride } from '../modalOverrides';

const ConfirmationBox = ({
  open = false,
  hideCloseButton = false, // eslint-disable-line no-unused-vars
  setOpen,
  header = '',
  children,
  onClose = () => {}
}) => {
  const handleModalClose = () => {
    setOpen();
    onClose();
  };
  // Note: hideCloseButton prop is kept for backward compatibility but UDS Modal
  // doesn't support hiding the close button directly. If needed, this can be handled via CSS.
  return (
    <>
      {open && <ModalWidthOverride width="570px" />}
      <Modal
        isOpen={open}
        onClose={handleModalClose}
        variant={{ width: 'xl' }}
      >
        <div style={{ padding: '27px 19px' }}>
          {header && (
            <>
              <div style={{ fontSize: '20px', fontWeight: 700, color: '#2a2c2e' }}>{header}</div>
              <Spacer space={2} />
            </>
          )}
          <div style={{ maxHeight: '58vh' }}>
            {children}
          </div>
        </div>
      </Modal>
    </>
  );
};

ConfirmationBox.propTypes = {
  open: PropTypes.bool,
  hideCloseButton: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  header: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func
};

export default ConfirmationBox;
